"use strict";

exports.__esModule = true;
exports.default = exports.RestrictedRoute = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _reactRouter = require("react-router");

var _jsxFileName = "C:\\github\\os\\react-most-wanted\\packages\\rmw-shell\\src\\containers\\RestrictedRoute\\RestrictedRoute.js";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const RestrictedRoute = (_ref) => {
  let type = _ref.type,
      isAuthorised = _ref.isAuthorised,
      Component = _ref.component,
      _ref$fallbackComponen = _ref.fallbackComponent,
      FallbackComponent = _ref$fallbackComponen === void 0 ? false : _ref$fallbackComponen,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "isAuthorised", "component", "fallbackComponent"]);

  return (/*#__PURE__*/_react.default.createElement(_reactRouter.Route, _extends({}, rest, {
      render: props => {
        if (isAuthorised && type === 'private' || !isAuthorised && type === 'public') {
          return (/*#__PURE__*/_react.default.createElement(Component, _extends({}, props, {
              __self: void 0,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 17,
                columnNumber: 16
              }
            }))
          );
        } else if (FallbackComponent) {
          return (/*#__PURE__*/_react.default.createElement(FallbackComponent, _extends({}, props, {
              __self: void 0,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 19,
                columnNumber: 16
              }
            }))
          );
        } else {
          return (/*#__PURE__*/_react.default.createElement(_reactRouter.Redirect, {
              to: {
                pathname: type === 'private' ? '/signin' : props.location.state ? props.location.state.from.pathname : '/',
                search: "from=" + props.location.pathname,
                state: {
                  from: props.location
                }
              },
              __self: void 0,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 22,
                columnNumber: 11
              }
            })
          );
        }
      },
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 13,
        columnNumber: 3
      }
    }))
  );
};

exports.RestrictedRoute = RestrictedRoute;
RestrictedRoute.propTypes = process.env.NODE_ENV !== "production" ? {
  isAuthorised: _propTypes.default.bool.isRequired
} : {};

const mapStateToProps = state => {
  const auth = state.auth;
  return {
    isAuthorised: auth.isAuthorised
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(RestrictedRoute);

exports.default = _default;